shadow$provide[98] = function(require,module,exports) {
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Strip = exports.Stereographic4 = exports.Stereographic = exports.Step = exports.Spread = exports.Split = exports.Spherical = exports.Slide = exports.Slice = exports.Shader = exports.Scale = exports.Rtt = exports.Reveal = exports.Retext = exports.Resample = exports.Repeat = exports.Readback = exports.Present = exports.Polar = exports.Point = exports.Play = exports.Now = exports.Move = exports.Memo = exports.Matrix = exports.Mask = exports.Line = exports.Lerp = exports.Layer = exports.Label = exports.Join = exports.Interval = exports.Inherit = exports.Html = exports.Grow = exports.Group = exports.Grid = exports.Fragment = exports.Format = exports.Face = exports.Dom = exports.Compose = exports.Clock = exports.Clamp = exports.Cartesian4 = exports.Cartesian = exports.Camera = exports.Axis = exports.Array = exports.Area = void 0;
exports.Voxel = exports.Volume = exports.View = exports.Vertex = exports.Vector = exports.Unit = exports.Transpose = exports.Transform4 = exports.Transform = exports.Ticks = exports.Text = exports.Swizzle = exports.Surface = exports.Subdivide = void 0;
var react_1 = __importStar(require("react"));
var MathboxAPIContext_1 = __importDefault(require("./MathboxAPIContext"));
var util_1 = require("./util");
var mathboxComponentFactory = function (type) {
    var canHaveChildren = (0, util_1.canNodeHaveChildren)(type);
    var componentName = (0, util_1.capitalize)(type);
    var Comp = function (props, ref) {
        var _a = (0, react_1.useReducer)(function (x) { return x + 1; }, 0), _ignored = _a[0], forceUpdate = _a[1];
        var parent = (0, react_1.useContext)(MathboxAPIContext_1["default"]);
        var selection = (0, react_1.useRef)(null);
        var prevLiveProps = (0, react_1.useRef)(undefined);
        (0, react_1.useEffect)(function () { return function () {
            if (selection.current) {
                selection.current.remove();
                selection.current = null;
            }
        }; }, []);
        (0, react_1.useImperativeHandle)(ref, function () { return selection.current; });
        var children = props.children, liveProps = props.liveProps, others = __rest(props, ["children", "liveProps"]);
        (0, react_1.useEffect)(function () {
            if (!parent)
                return;
            if ((0, util_1.isRootDestroyed)(parent)) {
                forceUpdate();
                return;
            }
            if (selection.current) {
                if (!(0, util_1.isSelectionParent)(selection.current, parent)) {
                    selection.current.remove();
                    selection.current = null;
                    forceUpdate();
                }
            }
            if (!selection.current) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                selection.current = parent[type](others, liveProps);
                forceUpdate();
            }
            else {
                /**
                 * If liveProps have changed, remove all the old liveProps.
                 * (The same prop cannot be re-assigned live without being un-assigned
                 * first.)
                 *
                 * We could unbind just the ones that have changed, but simpler to
                 * unbind them all.
                 */
                if (prevLiveProps.current && liveProps !== prevLiveProps.current) {
                    Object.keys(prevLiveProps.current).forEach(function (key) {
                        // @ts-expect-error this is not in ts yet
                        selection.current.unbind(key);
                    });
                }
                if (liveProps && liveProps !== prevLiveProps.current) {
                    selection.current.bind(liveProps);
                }
                selection.current.set(others);
            }
            prevLiveProps.current = liveProps;
        }, [parent, others, liveProps]);
        if (!canHaveChildren) {
            if (props.children) {
                throw new Error("Component <".concat(componentName, " /> cannot have children."));
            }
            return null;
        }
        return (react_1["default"].createElement(MathboxAPIContext_1["default"].Provider, { value: selection.current }, props.children));
    };
    /**
     * The line below gives a TS error without explicit any.
     * But if you replace each generic T above with a specific instance, e.g.,
     * 'cartesian', there is no error.
     *
     * So an alternative without "any" would be be to copy the definition of Comp
     * with all ~64 different node types.
     *
     * I'm not 100% sure why there's a ts error here, but the above indicates to
     * me that this is actually type-safe. And I do not want that much copy pasta.
     * So instead, use the any and put explicit return type on the factory.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (0, react_1.forwardRef)(Comp);
};
/**
 * Component wrapper for mathbox [`area`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#dataarea).
 */
exports.Area = mathboxComponentFactory("area");
/**
 * Component wrapper for mathbox [`array`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#dataarray).
 */
var MBArray = mathboxComponentFactory("array");
exports.Array = MBArray;
/**
 * Component wrapper for mathbox [`axis`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawaxis).
 */
exports.Axis = mathboxComponentFactory("axis");
/**
 * Component wrapper for mathbox [`camera`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#cameracamera).
 */
exports.Camera = mathboxComponentFactory("camera");
/**
 * Component wrapper for mathbox [`cartesian`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewcartesian).
 */
exports.Cartesian = mathboxComponentFactory("cartesian");
/**
 * Component wrapper for mathbox [`cartesian4`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewcartesian4).
 */
exports.Cartesian4 = mathboxComponentFactory("cartesian4");
/**
 * Component wrapper for mathbox [`clamp`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorclamp).
 */
exports.Clamp = mathboxComponentFactory("clamp");
/**
 * Component wrapper for mathbox [`clock`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#timeclock).
 */
exports.Clock = mathboxComponentFactory("clock");
/**
 * Component wrapper for mathbox [`compose`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#rttcompose).
 */
exports.Compose = mathboxComponentFactory("compose");
/**
 * Component wrapper for mathbox [`dom`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#overlaydom).
 */
exports.Dom = mathboxComponentFactory("dom");
/**
 * Component wrapper for mathbox [`face`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawface).
 */
exports.Face = mathboxComponentFactory("face");
/**
 * Component wrapper for mathbox [`format`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#textformat).
 */
exports.Format = mathboxComponentFactory("format");
/**
 * Component wrapper for mathbox [`fragment`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#transformfragment).
 */
exports.Fragment = mathboxComponentFactory("fragment");
/**
 * Component wrapper for mathbox [`grid`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawgrid).
 */
exports.Grid = mathboxComponentFactory("grid");
/**
 * Component wrapper for mathbox [`group`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#basegroup).
 */
exports.Group = mathboxComponentFactory("group");
/**
 * Component wrapper for mathbox [`grow`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorgrow).
 */
exports.Grow = mathboxComponentFactory("grow");
/**
 * Component wrapper for mathbox [`html`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#overlayhtml).
 */
exports.Html = mathboxComponentFactory("html");
/**
 * Component wrapper for mathbox [`inherit`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#baseinherit).
 */
exports.Inherit = mathboxComponentFactory("inherit");
/**
 * Component wrapper for mathbox [`interval`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#datainterval).
 */
exports.Interval = mathboxComponentFactory("interval");
/**
 * Component wrapper for mathbox [`join`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorjoin).
 */
exports.Join = mathboxComponentFactory("join");
/**
 * Component wrapper for mathbox [`label`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#textlabel).
 */
exports.Label = mathboxComponentFactory("label");
/**
 * Component wrapper for mathbox [`layer`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#transformlayer).
 */
exports.Layer = mathboxComponentFactory("layer");
/**
 * Component wrapper for mathbox [`lerp`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorlerp).
 */
exports.Lerp = mathboxComponentFactory("lerp");
/**
 * Component wrapper for mathbox [`line`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawline).
 */
exports.Line = mathboxComponentFactory("line");
/**
 * Component wrapper for mathbox [`mask`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#transformmask).
 */
exports.Mask = mathboxComponentFactory("mask");
/**
 * Component wrapper for mathbox [`matrix`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#datamatrix).
 */
exports.Matrix = mathboxComponentFactory("matrix");
/**
 * Component wrapper for mathbox [`memo`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatormemo).
 */
exports.Memo = mathboxComponentFactory("memo");
/**
 * Component wrapper for mathbox [`move`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#presentmove).
 */
exports.Move = mathboxComponentFactory("move");
/**
 * Component wrapper for mathbox [`now`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#timenow).
 */
exports.Now = mathboxComponentFactory("now");
/**
 * Component wrapper for mathbox [`play`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#presentplay).
 */
exports.Play = mathboxComponentFactory("play");
/**
 * Component wrapper for mathbox [`point`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawpoint).
 */
exports.Point = mathboxComponentFactory("point");
/**
 * Component wrapper for mathbox [`polar`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewpolar).
 */
exports.Polar = mathboxComponentFactory("polar");
/**
 * Component wrapper for mathbox [`present`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#presentpresent).
 */
exports.Present = mathboxComponentFactory("present");
/**
 * Component wrapper for mathbox [`readback`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorreadback).
 */
exports.Readback = mathboxComponentFactory("readback");
/**
 * Component wrapper for mathbox [`repeat`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorrepeat).
 */
exports.Repeat = mathboxComponentFactory("repeat");
/**
 * Component wrapper for mathbox [`resample`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorresample).
 */
exports.Resample = mathboxComponentFactory("resample");
/**
 * Component wrapper for mathbox [`retext`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#textretext).
 */
exports.Retext = mathboxComponentFactory("retext");
/**
 * Component wrapper for mathbox [`reveal`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#presentreveal).
 */
exports.Reveal = mathboxComponentFactory("reveal");
/**
 * Component wrapper for mathbox [`rtt`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#rttrtt).
 */
exports.Rtt = mathboxComponentFactory("rtt");
/**
 * Component wrapper for mathbox [`scale`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#datascale).
 */
exports.Scale = mathboxComponentFactory("scale");
/**
 * Component wrapper for mathbox [`shader`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#shadershader).
 */
exports.Shader = mathboxComponentFactory("shader");
/**
 * Component wrapper for mathbox [`slice`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorslice).
 */
exports.Slice = mathboxComponentFactory("slice");
/**
 * Component wrapper for mathbox [`slide`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#presentslide).
 */
exports.Slide = mathboxComponentFactory("slide");
/**
 * Component wrapper for mathbox [`spherical`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewspherical).
 */
exports.Spherical = mathboxComponentFactory("spherical");
/**
 * Component wrapper for mathbox [`split`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorsplit).
 */
exports.Split = mathboxComponentFactory("split");
/**
 * Component wrapper for mathbox [`spread`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorspread).
 */
exports.Spread = mathboxComponentFactory("spread");
/**
 * Component wrapper for mathbox [`step`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#presentstep).
 */
exports.Step = mathboxComponentFactory("step");
/**
 * Component wrapper for mathbox [`stereographic`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewstereographic).
 */
exports.Stereographic = mathboxComponentFactory("stereographic");
/**
 * Component wrapper for mathbox [`stereographic4`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewstereographic4).
 */
exports.Stereographic4 = mathboxComponentFactory("stereographic4");
/**
 * Component wrapper for mathbox [`strip`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawstrip).
 */
exports.Strip = mathboxComponentFactory("strip");
/**
 * Component wrapper for mathbox [`subdivide`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorsubdivide).
 */
exports.Subdivide = mathboxComponentFactory("subdivide");
/**
 * Component wrapper for mathbox [`surface`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawsurface).
 */
exports.Surface = mathboxComponentFactory("surface");
/**
 * Component wrapper for mathbox [`swizzle`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatorswizzle).
 */
exports.Swizzle = mathboxComponentFactory("swizzle");
/**
 * Component wrapper for mathbox [`text`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#texttext).
 */
exports.Text = mathboxComponentFactory("text");
/**
 * Component wrapper for mathbox [`ticks`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawticks).
 */
exports.Ticks = mathboxComponentFactory("ticks");
/**
 * Component wrapper for mathbox [`transform`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#transformtransform).
 */
exports.Transform = mathboxComponentFactory("transform");
/**
 * Component wrapper for mathbox [`transform4`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#transformtransform4).
 */
exports.Transform4 = mathboxComponentFactory("transform4");
/**
 * Component wrapper for mathbox [`transpose`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#operatortranspose).
 */
exports.Transpose = mathboxComponentFactory("transpose");
/**
 * Component wrapper for mathbox [`unit`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#baseunit).
 */
exports.Unit = mathboxComponentFactory("unit");
/**
 * Component wrapper for mathbox [`vector`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#drawvector).
 */
exports.Vector = mathboxComponentFactory("vector");
/**
 * Component wrapper for mathbox [`vertex`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#transformvertex).
 */
exports.Vertex = mathboxComponentFactory("vertex");
/**
 * Component wrapper for mathbox [`view`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#viewview).
 */
exports.View = mathboxComponentFactory("view");
/**
 * Component wrapper for mathbox [`volume`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#datavolume).
 */
exports.Volume = mathboxComponentFactory("volume");
/**
 * Component wrapper for mathbox [`voxel`](https://gitgud.io/unconed/mathbox/-/blob/master/docs/primitives.md#datavoxel).
 */
exports.Voxel = mathboxComponentFactory("voxel");
//# sourceMappingURL=components.js.map
};